module.exports = __webpack_public_path__ + "img/stop-icon.bce24ec2.svg";